export enum ErrorCode {
	NotFound = 400,
	Unauthorized = 401,
	Aborted = 999,
}

export class UnknownError extends Error {
	constructor(message?: string) {
		super(message);
		this.name = "UnknownError";
	}
}

export class ApiClientError extends Error {
	constructor(
		message: string,
		public status: ErrorCode,
	) {
		super(message);
	}
}

export class AbortedApiClientError extends ApiClientError {
	constructor(message: string) {
		super(message, ErrorCode.Aborted);
	}
}

export function unwrap(error: unknown): ApiClientError {
	if (error instanceof ApiClientError) {
		return error;
	}

	return new ApiClientError(`Unknown error: ${error}`, 400);
}
